// The storefront's version and the oldest one allowed to keep running (F173;
// bumped with `make landing-…`), and the commit it was built from ("dev" on
// dev), all baked in at build time by next.config.js. docs/storefront-updates.md.
export const SITE_VERSION = process.env.NEXT_PUBLIC_SITE_VERSION ?? "0.0.0";
export const SITE_MIN_VERSION = process.env.NEXT_PUBLIC_SITE_MIN_VERSION ?? "0.0.0";
export const SITE_COMMIT = process.env.NEXT_PUBLIC_SITE_COMMIT ?? "dev";

// Where the commit is never shown: prod (the user's choice, 2026-10-19).
// Staging and prod run the same image, so the host is what tells them apart.
export const NO_COMMIT_HOSTS = ["shemshop.ir", "www.shemshop.ir"];

/** Semver order of "x.y.z" strings: negative when a < b. Anything malformed counts as 0.0.0. */
export function compareVersions(a: string, b: string): number {
  const parse = (v: string) => (/^(\d+)\.(\d+)\.(\d+)$/.exec(v)?.slice(1).map(Number) ?? [0, 0, 0]);
  const [x, y] = [parse(a), parse(b)];
  for (let i = 0; i < 3; i++) if (x[i] !== y[i]) return x[i]! - y[i]!;
  return 0;
}
